<template>
  <div class="panel_sale">
    <div class="list" v-if="type === 'list'">
      <pharmacyList></pharmacyList>
    </div>
    <div class="add" v-if="type === 'edit'">
      <pharmacyEdit></pharmacyEdit>
    </div>
    <div class="add" v-if="type === 'see'">
      <pharmacySee></pharmacySee>
    </div>
  </div>
</template>
<script>
import pharmacyList from "../comp/pharmacy_list.vue";
import pharmacyEdit from "../comp/pharmacy_edit.vue";
import pharmacySee from "../comp/pharmacy_see.vue";
export default {
  components: { pharmacyList, pharmacyEdit, pharmacySee },
  data() {
    return {};
  },
  computed: {
    type() {
      return this.$store.state.yiliaoxin.yaofangParams.type;
    },
  },
  mounted() {},
  methods: {},
};
</script>
<style scoped lang="scss">
.panel_sale {
  width: 100%;
  height: calc(100% - 145px);
  margin-top: 12px;
  .list {
    height: 100%;
  }
  .add {
    height: 100%;
  }
}
</style>
